import { Box, Container, Header, SpaceBetween } from "@amzn/awsui-components-react";
import { FC } from "react";
import Layout from "../layout/Layout";

interface ViewerV2PlaceholderProps {
    /** Which viewer mode this placeholder stands in for (single / compare / slider). */
    mode: "single" | "compare" | "slider";
}

const MODE_LABELS: Record<ViewerV2PlaceholderProps["mode"], string> = {
    single: "Viewer 2.0 (MapLibre)",
    compare: "Viewer 2.0 — Compare (MapLibre)",
    slider: "Viewer 2.0 — Slider (MapLibre)",
};

/**
 * Temporary placeholder for the experimental MapLibre-based Viewer 2.0.
 * The real engine, state, and UI land in later chunks (see docs/viewer-v2/PLAN.md).
 * This exists so the routes and the flag-gated nav entry resolve to something
 * while the C1–C11 chunks are built and merged.
 */
const ViewerV2Placeholder: FC<ViewerV2PlaceholderProps> = ({ mode }) => {
    return (
        <Layout>
            <Container header={<Header variant="h1">{MODE_LABELS[mode]}</Header>}>
                <SpaceBetween size="m">
                    <Box variant="p">
                        This experimental viewer is under construction. The MapLibre engine,
                        configuration bar, and on-map controls are being implemented incrementally.
                    </Box>
                    <Box variant="small" color="text-status-inactive">
                        See docs/viewer-v2/PLAN.md for the implementation plan.
                    </Box>
                </SpaceBetween>
            </Container>
        </Layout>
    );
};

export default ViewerV2Placeholder;
